import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "currentColor", opacity: 0.2 }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M14.884 13c0-.184.15-.333.333-.333q1.378 0 2.756.223c.51.083.927.454 1.069.951l.207.728.02.079c.154.704-.304 1.396-1 1.585-.67.18-1.426.319-2.03.386a.333.333 0 0 1-.369-.295 11 11 0 0 0-.357-1.676c-.25-.8-.63-1.554-.63-1.648m-1.667-3a2.001 2.001 0 0 1 4 0 2.001 2.001 0 0 1-4 0m-3.333 8c-1.985 0-3.444-.188-4.388-.574a1.33 1.33 0 0 1-.804-1.495l.26-1.3a2.33 2.33 0 0 1 2.09-1.868 35 35 0 0 1 2.842-.096q1.704 0 2.842.096a2.33 2.33 0 0 1 2.09 1.869l.26 1.299a1.33 1.33 0 0 1-.804 1.495c-.945.386-2.403.574-4.388.574M7.217 8.667A2.67 2.67 0 0 1 9.884 6a2.67 2.67 0 0 1 2.666 2.667 2.67 2.67 0 0 1-2.666 2.666 2.67 2.67 0 0 1-2.667-2.666",
      clipRule: "evenodd"
    }
  )
);
var SvgCircledConferenceFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CircledConferenceFilled_default = SvgCircledConferenceFilled;

export { CircledConferenceFilled_default as default };
